import { useAverageActiveViewportDuration } from '@va/dashboard/api-client/visitor-stats';
import { useSessionMetricsFilters } from '@va/dashboard/shared/filters';
import { useTranslate } from '@va/localization';
import { FiltersContextProvider } from '@va/shared/feature-filters';
import { TimePeriod } from '@va/types/time';
import { DateComparisonPeriod } from '@va/ui/components/report-block';
import { formatMomentDuration, formatTime } from '@va/util/helpers';
import { isNil } from 'lodash';
import moment from 'moment';
import { useCallback } from 'react';
import { useCurrentVisitorStatsParams, usePreviousVisitorStatsParams } from '../expandable-rb/useVisitorStatsParams';
import { VisitorStatsReport } from '../expandable-rb/VisitorStatsReport';

const useCurrent = (unit: TimePeriod = TimePeriod.day) => {
  const params = useCurrentVisitorStatsParams();
  return useAverageActiveViewportDuration({ ...params, unit });
};
const usePrevious = (activeComparisonOption: DateComparisonPeriod, unit: TimePeriod = TimePeriod.day) => {
  const params = usePreviousVisitorStatsParams(activeComparisonOption);
  return useAverageActiveViewportDuration({ ...params, unit });
};

const ActiveViewportTimeCard = ({
  id,
  gridPosition,
  canExpand,
}: {
  id: string;
  gridPosition: number;
  canExpand?: boolean;
}) => {
  const translate = useTranslate();

  const valueMapper = useCallback(
    (val: number | string) =>
      isNil(val) ? translate('all.notApplicable') : formatTime(formatMomentDuration(moment.duration(val, 'seconds'))),
    [translate],
  );

  const { allFilters } = useSessionMetricsFilters();

  return (
    <FiltersContextProvider allFilterOptions={allFilters} reportBlockId={id}>
      <VisitorStatsReport
        id={id}
        gridPosition={gridPosition}
        canExpand={canExpand}
        fetchCurrentHook={useCurrent}
        fetchPreviousHook={usePrevious}
        valueMapper={valueMapper}
        headingValueMapper={valueMapper}
        title={translate('card.activeViewportTime.title')}
        titleTooltip={translate('card.activeViewportTime.tooltip')}
        yAxisTickCallback={valueMapper}
        showTimePeriodFilter
      />
    </FiltersContextProvider>
  );
};

export default ActiveViewportTimeCard;
